import React from "react";

const PermissionsTableHeader = ({ permissionLabels }) => {
  return (
    <thead>
      <tr className="bg-white sticky top-0 z-10 px-5">
        <th className="pl-10 pb-2 text-left border-b border-gray-200 text-customBlue">
          Permission Item
        </th>
        {permissionLabels.map((label) => (
          <th
            key={label}
            className="p-1 pb-2 min-w-[100px] border-b border-gray-200 text-customBlue"
          >
            <div className="flex justify-center">{label}</div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default PermissionsTableHeader;
